export class WechatSettingModel {
    constructor() {
    }
    H5url: string = "";
    IsOpenWx: boolean = false;
    ScancodeBindingUrl: string = "";
    ScancodeLoginUrl: string = "";
    ScancodeRegisterCallbackUrl: string = "";
    ScancodeRegisterUrl: string = "";
    ScancodeSuccessCallbackUrl: string = "";
    ScancodeUntieUrl: string = "";
    ShortUrlHost: string = "";
    SinaKey: string = "";
    WapJumpUrl: string = "";
    WapScancodeLoginUrl: string = "";
    WxAppID: string = "";
    WxAppsecret: string = "";
}


// WEBPACK FOOTER //
// ./src/models/wechat.model.ts